var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('Header'),_c('PageHeader',{scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('b-icon-clipboard-plus',{staticClass:"ml-3"}),_vm._v(" Create User ")]},proxy:true}])}),_c('b-container',{staticClass:"my-5",attrs:{"fluid":""}},[_c('b-card',{staticClass:"shadow-sm"},[_c('UserForm')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }